// extracted by mini-css-extract-plugin
export default {"box":"modal_box__Xbu8e","button":"modal_button__N7aRc","title":"modal_title__SSgO1"};